import getPlanTypeKey from './getPlanTypeKey'
import { getBenefits } from './getBenefits'

export interface ResponsePlansParserParams {
  responseData: any
}

const parseResponseToInitStore = ({ responseData }: ResponsePlansParserParams) => {
  const { plans } = responseData

  const parsedPlans = Object.keys(plans)
    .map(planId => {
      const plan = plans[planId]
      return {
        ...plan,
        planTypeKey: getPlanTypeKey(plan),
        benefits: getBenefits(plan)
      }
    })
    .reduce((acc, x) => ({ ...acc, [x.planId]: x }), {})

  return {
    ...responseData,
    plans: parsedPlans
  }
}

export default parseResponseToInitStore
